import { render, staticRenderFns } from "./AttachedItemsForm.vue?vue&type=template&id=df254932&scoped=true&"
import script from "./AttachedItemsForm.vue?vue&type=script&lang=js&"
export * from "./AttachedItemsForm.vue?vue&type=script&lang=js&"
import style0 from "./AttachedItemsForm.vue?vue&type=style&index=0&id=df254932&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df254932",
  null
  
)

/* custom blocks */
import block0 from "./AttachedItemsForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports